export default __webpack_public_path__ + "static/media/english-to-polish-screenshot-02.2e544ca3.png";